<template>
  <div>
    <el-select class="filter__input" size="mini" v-model="localValue" filterable placeholder="请选择" @change="$emit('input', $event)">
      <el-option :label="item.label" :value="item.value" v-for="(item, index) in localLists" :key="index"></el-option>
    </el-select>
  </div>
</template>
<script>
import {adConciseLists} from '../../api/api'
export default {
  props: {
    value: { // v-model 必须使用value名字
      type: [String, Number], // 必须为字符串
      required: true, // 必须传递该属性
      default: '' // 未传值时的默认值
    },
    lists: {
      type: Array, // 必须为字符串
      default: () => []
    },
    needEdit: {
      type: Boolean, // 必须为字符串
      required: false, // 必须传递该属性
      default: false // 未传值时的默认值
    }
  },
  data () {
    return {
      localValue: this.value,
      localLists: this.lists
    }
  },
  methods: {
    changeValue () {
      this.localValue = this.value
    },
    getLists () {
      let params = {
        l: 1000,
        p: 1
      }
      adConciseLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.localLists = data.d.lists.map((item, index) => {
            return {
              label: item.title + '(' + item.adid + ')',
              value: item.adid,
              title: item.title + '(' + item.adid + ')',
              adid: item.adid
            }
          })
          if (this.needEdit === false) {
            this.localLists.unshift({
              label: '所有',
              value: '',
              title: '所有',
              adid: ''
            })
          }
          this.$emit('update:lists', this.localLists)
        }
      })
    }
  },
  mounted () {
    this.getLists()
  },
  watch: {
    'value': 'changeValue'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data-select/adSelect.vue